var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-23.851 244.054 215.677)",
    d: "M-9.5 200.4h507.2v30.5H-9.5z",
    fill: "#232323",
    className: "fill-232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m506 99.9-95.7-15.5 42.8 96.7z",
    fill: "#232323",
    className: "fill-232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 427.6h65.7v-120l-65.7 29z",
    fill: "#000000",
    className: "fill-cce134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.8 427.6h65.7V263.7l-65.7 29.1z",
    fill: "#000000",
    className: "fill-2e4356"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247 427.6h65.7V219.8L247 248.9z",
    fill: "#000000",
    className: "fill-f4908c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.3 427.6H412V176l-65.7 29z",
    fill: "#000000",
    className: "fill-fbd502"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.761c7aaebb3921576117c0c06fa24ad1.svg";
export { ForwardRef as ReactComponent };